/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"ActiveCommentsQuery",
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"BlogTreeRootComponentQuery",
	"CollabDraftQuery",
	"CollabDraftWithRelevanceQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"ContentUnifiedWithSpaceKeyQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageRestrictionsContextQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WebStorageCategories",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery",
	"bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksQuery",
	"preloadCreateSpaceQuery",
	"preloadEditButtonWithSpaceKeyQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPendingRequestExistsQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadSpaceBlogCountQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"relay_ApprovalsContextApprovalsDataQuery",
	"relay_ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"relay_BlogTreeRootComponentQuery",
	"relay_CollabDraftQuery",
	"relay_ContentHeaderPresenceContentSettingsQuery",
	"relay_ContentHeaderUnifiedQuery",
	"relay_ContentTypesHeaderQuery",
	"relay_ContentUnifiedQuery",
	"relay_ContentUnifiedWithSpaceKeyQuery",
	"relay_CoverPictureQuery",
	"relay_CustomHeaderFooterQuery",
	"relay_EditContentButtonQuery",
	"relay_EditorContentStateQuery",
	"relay_EditorPreferencesQuery",
	"relay_EmojiTitleQuery",
	"relay_EndOfPageRecommendationQuery",
	"relay_FollowingFeedWithSortByStorageSnippetsQuery",
	"relay_FooterCreateButtonsQuery",
	"relay_HomeRecentWorkQuery",
	"relay_LivePagesByLineLastUpdatedQuery",
	"relay_NativeCollabQuery",
	"relay_NotificationsButtonQuery",
	"relay_PageRestrictionsContextQuery",
	"relay_PageTreeQuery",
	"relay_PageTreeQueryWithSpaceKeyQuery",
	"relay_PermissionCheckAddCommentQuery",
	"relay_PersistentInviteEligibleQuery",
	"relay_PersonalizedTemplatesV2AllTemplatesQuery",
	"relay_PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"relay_ReactionsContentQuery",
	"relay_RendererContentStateQuery",
	"relay_RestrictedPageWithCanViewQuery",
	"relay_ScreenQuery",
	"relay_SiteInformationQuery",
	"relay_SmartCreateFeedbackBannerQuery",
	"relay_SpaceNavigationQuery",
	"relay_SpaceOverviewIdQuery",
	"relay_SpaceOverviewQuery",
	"relay_SpaceOverviewSwitcherQuery",
	"relay_SpaceRestrictionCheckQuery",
	"relay_ThemeQuery",
	"relay_TopNavigationQuery",
	"relay_ViewSpaceExternalCollaboratorsDialogQuery",
	"relay_WebItemLocationQuery_page.metadata.banner",
	"relay_WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"relay_WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"relay_WebItemLocationQuery_system.content.byline",
	"relay_WebItemLocationQuery_system.header_left",
	"relay_WebPanelLocationQuery_atl.footer",
	"relay_WebPanelLocationQuery_atl.general",
	"relay_WebPanelLocationQuery_atl.page.content.footer.actions",
	"relay_WelcomeMessagesQuery",
	"relay_contentAppearanceQuery",
	"relay_fetchMentionsProviderDataQuery",
	"relay_graphqlHelpersDSPIsActionEnabledForContentQuery",
	"relay_graphqlHelpersFetchMediaTokenQuery",
	"relay_loomUserPermissionQuery",
	"relay_multiMacroQueryWithAppKeyQuery",
	"relay_onboardingStateGetOnboardingStateQuery",
	"relay_onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"relay_onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"relay_onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"relay_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"relay_onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"relay_onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"relay_onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"relay_preloadAutohighlightsQuery",
	"relay_preloadCreateSpaceQuery",
	"relay_preloadEditButtonWithSpaceKeyQuery",
	"relay_preloadEditorNodeDataProvidersDataQuery",
	"relay_preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"relay_preloadPersonalSpaceDetailsQuery",
	"relay_preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"relay_preloadTemplatesCollectionEligibleQuery",
	"relay_shortcutsSmartLinksQuery",
	"relay_useAnalyticsByLineQuery",
	"relay_useAudioContentQuery",
	"relay_useConfluenceStandardToPremiumExperimentQuery",
	"relay_useConnectorOnboardingStateQuery",
	"relay_useConnectorOnboardingTeamTypeQuery",
	"relay_useConnectorStatesQuery",
	"relay_useContentClassificationContentDataClassificationQuery",
	"relay_useEditorContentModeValueQuery",
	"relay_useEmojiEverSetPropertyQuery",
	"relay_useFabricEligibilityMigrationQuery",
	"relay_useFeatureDiscoveryFeatureDiscoveryQuery",
	"relay_useFeedTypeSelectorRefreshQuery",
	"relay_useGetCurrentStorageUsageQuery",
	"relay_useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"relay_useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"relay_useHomeWidgetStateQuery",
	"relay_useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"relay_useIsLoomEntryPointsEnabledQuery",
	"relay_useIsUserViewingSpaceAsAnonQuery",
	"relay_useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"relay_useLoomTenantProvisionStatusQuery",
	"relay_usePopularFeedWithTimeGranularityStorageQuery",
	"relay_usePreloadCommentButtonQuery",
	"relay_useReadTimeQuery",
	"relay_useRegisterAdminAnnouncementBannerQuery",
	"relay_useShareAndRestrictButtonDataQuery",
	"relay_useSpaceBaseQueryBaseQuery",
	"relay_useSpaceDetailQuery",
	"relay_useSpaceEnabledContentTypesQuery",
	"relay_useSpaceViewsDataSpaceRootQuery",
	"relay_useSpaceViewsOptionsPersistenceQuery",
	"relay_useSpacesDataMyVisitedSpacesQuery",
	"relay_useSpacesDataStarredSpacesQuery",
	"relay_useTitleContentPropertiesForEditorQuery",
	"relay_useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"relay_useTitleContentPropertiesForPublishedPageQuery",
	"relay_useUserByLicensedProductsQuery",
	"requireSuperBatchFrontendResourceRenderQuery",
	"rightPanel",
	"searchCombinedConfig",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAnalyticsByLineQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useConfluenceStandardToPremiumExperimentQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useFollowingFeedWithSortByStorageFeedContentQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePreloadCommentButtonQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useShortcutsSpaceNavigationQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "9e5f7b0effebffff5bd67fffffff0200000000000000000000000000009be2e7bef7f9",
	"prod-apne2": "9e5f7b5effebffff5bd67fffffff0300000000000000000000000000009aeef79ef7f9",
	"prod-apse": "9edf7b7effebffff5bd67fffffff0200000000000000000000000000009be2f7bef7f9",
	"prod-apse2": "9edf7b5effebffff5fd77fffffff0300000000000000000000000000009beef7bef7ff",
	"prod-apsouth": "9e7f7b4effebffffdbd77fffffff030000000000000000000000000000daeef79ef7fd",
	"prod-cacentral": "9eff7b6effefffff5fd77fffffff0300000000000000000000000000009afef79ff7fd",
	"prod-east": "9edf7f3effeeffff5fd77fffffff0300000000000000000000000000009bfef7bff7ff",
	"prod-eucentral": "9edf7f5e7feaffff5fd67fffffff0300000000000000000000000000009beef7bef7ff",
	"prod-eucentral2": "8edf7b46ffebffff4bd77bffffff0200000000000000000000000000009ae2f79ef7f9",
	"prod-euwest": "9edf7f7effefffff7fd77fffffff0300000000000000000000000000009beef7bff7ff",
	"prod-euwest2": "9eff7b7effefffff5fd77fffffff0300000000000000000000000000009aeef79ef7fd",
	"prod-west2": "9edf7fdeffefffff53d77fffffff0300000000000000000000000000009beef7bff7fb",
	"stg-east": "b5b3db0ed5ef163f5b55fd5c735fdaf1a83bdd3f3ebff3cafee6ff7defcfe2a7dfebdd"
};

export const generatedAt: string | null = "2026-07-30T03:09:05.004Z";
